function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.29,286a327.12,327.12,0,0,0,14.3-91.28c.5-31.86-3-66.31-24-90.19-20.62-23.35-53.71-31.33-84.84-32.69-12.61-.54-25.49-.18-37.46,3.82-24.17,8.08-41.11,29.51-62.55,43.29-41.39,26.6-97.31,23.45-137.1,52.39a114.69,114.69,0,0,0-26.24,27.15c-29,41.55-31.27,99.11-9.13,144.69S160.88,421.84,210.09,434,312.4,438.13,358,416C411.13,390.21,444.22,340.84,461.29,286Z",
    style: {
      fill: "#C0F3EA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.29,286a327.12,327.12,0,0,0,14.3-91.28c.5-31.86-3-66.31-24-90.19-20.62-23.35-53.71-31.33-84.84-32.69-12.61-.54-25.49-.18-37.46,3.82-24.17,8.08-41.11,29.51-62.55,43.29-41.39,26.6-97.31,23.45-137.1,52.39a114.69,114.69,0,0,0-26.24,27.15c-29,41.55-31.27,99.11-9.13,144.69S160.88,421.84,210.09,434,312.4,438.13,358,416C411.13,390.21,444.22,340.84,461.29,286Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-89"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.7,
    y: 106,
    width: 192.32,
    height: 60.15,
    rx: 11.22,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.36,
    y1: 135.81,
    x2: 446.43,
    y2: 135.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "311.27 135.81 331.97 121.22 384.69 121.22 406.2 135.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.28,135.81a4.09,4.09,0,1,1-4.08-4.09A4.09,4.09,0,0,1,410.28,135.81Z",
    style: {
      fill: "#C0F3EA",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.97,
    cy: 121.22,
    r: 4.09,
    style: {
      fill: "#C0F3EA",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.77,121.22a4.09,4.09,0,1,1-4.08-4.08A4.09,4.09,0,0,1,388.77,121.22Z",
    style: {
      fill: "#C0F3EA",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "311.27 135.81 331.97 150.4 429.13 150.4 446.43 135.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.71,150.4a4.09,4.09,0,1,1-4.09-4.09A4.09,4.09,0,0,1,367.71,150.4Z",
    style: {
      fill: "#C0F3EA",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.06,150.4a4.09,4.09,0,1,1-4.09-4.09A4.09,4.09,0,0,1,336.06,150.4Z",
    style: {
      fill: "#C0F3EA",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.22,150.4a4.09,4.09,0,1,1-4.09-4.09A4.09,4.09,0,0,1,433.22,150.4Z",
    style: {
      fill: "#C0F3EA",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.43,
    cy: 135.81,
    r: 4.09,
    style: {
      fill: "#C0F3EA",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.36,135.81a4.09,4.09,0,1,1-4.08-4.09A4.09,4.09,0,0,1,315.36,135.81Z",
    style: {
      fill: "#C0F3EA",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.98,
    y: 232.7,
    width: 120.31,
    height: 120.31,
    rx: 11.22,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "128.09 301.39 112.51 331.68 183.13 331.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "183.13 255.63 150.17 277.54 183.13 287.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.34,
    y: 247.84,
    width: 15.58,
    height: 15.58,
    style: {
      fill: "#C0F3EA",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.34,
    y: 279.67,
    width: 15.58,
    height: 15.58,
    style: {
      fill: "#C0F3EA",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.38,
    y: 269.75,
    width: 15.58,
    height: 15.58,
    style: {
      fill: "#C0F3EA",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.3,
    y: 293.6,
    width: 15.58,
    height: 15.58,
    style: {
      fill: "#C0F3EA",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.72,
    y: 323.88,
    width: 15.58,
    height: 15.58,
    style: {
      fill: "#C0F3EA",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.34,
    y: 323.88,
    width: 15.58,
    height: 15.58,
    style: {
      fill: "#C0F3EA",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.93,
    y: 185.55,
    width: 120.31,
    height: 120.31,
    rx: 11.22,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 197.19,
    width: 80.03,
    height: 6.2,
    style: {
      fill: "#C0F3EA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 207.4,
    width: 46.24,
    height: 6.2,
    style: {
      fill: "#C0F3EA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 217.61,
    width: 26.93,
    height: 6.2,
    style: {
      fill: "#C0F3EA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 227.81,
    width: 44.32,
    height: 6.2,
    style: {
      fill: "#C0F3EA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 238.02,
    width: 69.09,
    height: 6.2,
    style: {
      fill: "#C0F3EA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 248.22,
    width: 46.24,
    height: 6.2,
    style: {
      fill: "#C0F3EA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 258.43,
    width: 32.26,
    height: 6.2,
    style: {
      fill: "#C0F3EA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 268.64,
    width: 52.23,
    height: 6.2,
    style: {
      fill: "#C0F3EA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 278.84,
    width: 63.32,
    height: 6.2,
    style: {
      fill: "#C0F3EA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 289.05,
    width: 80.03,
    height: 6.2,
    style: {
      fill: "#C0F3EA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 197.19,
    width: 80.03,
    height: 6.2,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 207.4,
    width: 46.24,
    height: 6.2,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 217.61,
    width: 26.93,
    height: 6.2,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 227.81,
    width: 44.32,
    height: 6.2,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 238.02,
    width: 69.09,
    height: 6.2,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 248.22,
    width: 46.24,
    height: 6.2,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 258.43,
    width: 32.26,
    height: 6.2,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 268.64,
    width: 52.23,
    height: 6.2,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 278.84,
    width: 63.32,
    height: 6.2,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 289.05,
    width: 80.03,
    height: 6.2,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.19,175h29.12a5.3,5.3,0,0,1,5.3,5.3v5.27a0,0,0,0,1,0,0H84.89a0,0,0,0,1,0,0v-5.27A5.3,5.3,0,0,1,90.19,175Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5,175H99.28a5.48,5.48,0,0,1,5.48,5.48v5.1a0,0,0,0,1,0,0H65a0,0,0,0,1,0,0v-5.1A5.48,5.48,0,0,1,70.5,175Z",
    style: {
      fill: "#C0F3EA",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.37,175H77.85A5.13,5.13,0,0,1,83,180.1v5.45a0,0,0,0,1,0,0H43.25a0,0,0,0,1,0,0V180.1A5.13,5.13,0,0,1,48.37,175Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-89"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 423.18,
    y1: 395.54,
    x2: 445.05,
    y2: 395.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.67,
    y1: 395.54,
    x2: 411.67,
    y2: 395.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coffee--inject-189--inject-89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.18,382.73s3.87-3.17,5.72.29c1.59,3-2.22,6.35-6.57,6.35v2.53s9.32.25,10-7.6-9.19-5.68-9.19-5.68Z",
    style: {
      fill: "#C0F3EA",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.86 395.49 398.2 395.49 395.4 372.06 419.66 372.06 416.86 395.49",
    style: {
      fill: "#C0F3EA",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.16,
    y: 370.94,
    width: 26.74,
    height: 2.68,
    rx: 1.28,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M404.36,368.39s8.58-5.15,5.78-11.06-12.27-9.8-12.27-19c0-7.92,8.42-10.85,13.92-14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.18,329.92a10.27,10.27,0,0,0-2.72,14.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.85,353.27A15.51,15.51,0,0,1,413.19,364",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,393.6s-.39-6.72-6.32-9.09-9.1-1.39-22.33,2.17a126.49,126.49,0,0,1-25.5,3.95v3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.81,393.6s.39-6.72,6.32-9.09,9.09-1.39,22.33,2.17A126.28,126.28,0,0,0,236,390.63v3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.49,
    y: 392.41,
    width: 111.66,
    height: 2.17,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.69,393.48a11.89,11.89,0,0,1,6.57-7.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.07,393a11,11,0,0,1,7.43-5.28c3.69-.68,7.45.59,10.93,2S216,393,219.72,393",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.4,392.39a40.34,40.34,0,0,0,10.77-2.7,47.15,47.15,0,0,1,6.42-2.46,8.87,8.87,0,0,1,6.66.67,9.1,9.1,0,0,1,2.29,2.13,16,16,0,0,1,2.17,3.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.82,389.37A5.29,5.29,0,0,1,173,391a16.1,16.1,0,0,1,2.11,2.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.6,392.52a33.09,33.09,0,0,1-13,3c-6.92,0-21-14.3-21-14.3s-.51-1.54.59-7.3,11.44-58.61,11.44-58.61,1.22-12.3,8.21-19.85,20.71-10.24,20.71-10.24,30.34-13.21,47.36-9.13c17,6.75,35.57,13.61,41.77,18.93s21.44,48,26.72,69.92c0,0-11.63,24.71-22.48,31.65s-37,4.68-37,4.68Z",
    style: {
      fill: "#C0F3EA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.75,349.57l-4.39-58.25a19.12,19.12,0,0,0-11.49,13.59c-2.27,10.42-16,74.55-14.3,76.33s10.65,9.45,10.65,9.45,9.65,8.25,19.53,3.32S262.75,349.57,262.75,349.57Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.31,296.72c-.51,1.74-2.7,2.3-4.52,2.32a21.54,21.54,0,0,1-14.27-5.2c-.72-.63-13.59,7.32-15.07,8.11-2.34,1.26-4.63,2.64-7,3.81-2.22,1.09-4.32,1.63-5.77,3.83a19.76,19.76,0,0,0-2.15,5.2c-3.12,10.22-6.41,20.41-9.25,30.7-2.46,8.91-5.77,18.77-5.63,28.12a14.83,14.83,0,0,0,.14,2c2,11.95,23.82,16.91,23.82,16.91s-7.72,4.73-13,3-17.62-8.79-21.51-15.39l10.71-56s-.13-27,19.33-35,27.1-9.23,27.1-9.23Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.12,384.81s8.5-9.39,11.25-19.85c0,0-13-42.94-16.38-51s-8.85-17.21-12.68-21.13l-6.22,88.38-1.31,18.6s7,.29,11.85-2S378.12,384.81,378.12,384.81Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.78,399.84l7.53-107s-36.46-17-46-18.62-55.87,16.64-55.87,16.64l6.74,102.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.06,222l-3.74,17.95s-4.8-3.39-5.82.44,2.1,9.1,8.13,9.39c0,0,1.64,8.13,7,13.65a99.72,99.72,0,0,0,8,7.64s2.11,13.63,9,14.15,8.23-5.68,9.62-14.3c0,0,5.95-10.32,7.69-15.9,0,0,7.3-5.09,2.43-12.52,0,0,2.41-17.77-1.78-20.77S294.37,220.26,287.06,222Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.29,286.64s-2.31,11.64-3.75,11.93-7.14-5.15-12.12-11.93-4.21-6.79-4.21-6.79,2.31-8.9,4.21-10.2,8.75-1.14,8.75-1.14l15-.57s5-.71,8.09,1.28,4.59,10.63,4.59,10.63-9,16.59-16.34,18.72A109.11,109.11,0,0,1,309.29,286.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.12,
    y1: 374.04,
    x2: 262.11,
    y2: 346.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.85,227.14s-8.52,3.3-16.05,2.67c0,0-7.95,8-18.13,3.25,0,0-9.18,24.86,11.87,41.12a36,36,0,0,1-21.91-24.41s-6,.93-8.13-8c0,0-1.73-3.45,6.16-3.47l-.34-17.3,20.27,4.07,14.55-2.13Z",
    style: {
      fill: "#C0F3EA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.85,227.14s-8.52,3.3-16.05,2.67c0,0-7.95,8-18.13,3.25,0,0-7.42,26.62,11,40.67,0,0-16.71-5.79-21.05-24,0,0-5.94-.63-8.13-8,0,0-1.73-3.45,6.16-3.47l-.34-17.3,20.27,4.07,14.55-2.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.68,261.6a21.61,21.61,0,0,0,2.07,1.48c.47.3,1.18.54,1.51.1a1.11,1.11,0,0,0,.17-.6c.3-4.91-.85-9.87-.15-14.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.51,245.05s2.44-5.38,8.73-.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0586793422698975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.6,246s-4.6-5.72-10.3.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0586793422698975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.39,270.21s2.45,14.67,11.09,15.12c7,.36,8.38-11.77,8.65-16.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5,241.58s-3.81-4.55-6.39-2.33,1.29,12,7.52,10.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,263.42a13.46,13.46,0,0,0,7.32,4.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 300.58,
    cy: 252.81,
    rx: 0.99,
    ry: 2.1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.62,252.81c0,1.16-.45,2.1-1,2.1s-1-.94-1-2.1.44-2.11,1-2.11S317.62,251.65,317.62,252.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.57,285.21s-2.4,13.07-4,13.36-13.91-10.87-16.33-18.72c0,0,2.6-10.26,5-10.63,1.13-.18,2.43-.35,3.46-.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.57,285.21s2.32,13.07,3.94,13.36,13.92-10.87,16.34-18.72c0,0-2.94-10.19-5.17-11.05a27.52,27.52,0,0,0-4.38-1.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.81,253.06c1.58,2.74,3.54-6.91,2.71-10-.56-2-1.65-3.94-1.75-6-.1-2.34,1-4.53,1.86-6.72s1.31-4.8,0-6.76a30.57,30.57,0,0,0,15.42,5.53,9.69,9.69,0,0,0,4.22-.34,4.14,4.14,0,0,0,2.74-3c5.2.66,10.35,1.34,15.53.63,4.35-.59,11.11-1.69,13.34-6.13,3.27-6.48-5.15-13.21-10.12-15.48-12-5.49-28.22-6.42-39.06,2.2a39.6,39.6,0,0,1-3.49,2.7c-2.39,1.5-7.83,2.66-9.74,4.75-2.56,2.81.65,24.51.65,24.51s4.18-1.94,5.9,4.53C286.22,247.84,285.21,250.3,286.81,253.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.13,225a4.85,4.85,0,0,0-.14.82,22.47,22.47,0,0,0,.87,7.29c.27,1.06.66,2.09.83,3.17.4,2.57.4,5.05,2.3,7.14,0,0,3.64-12.73,2.17-21.83-.17-1-.5-3.7-2.11-3.21-1.18.36-2,2.38-2.52,3.36A16.86,16.86,0,0,0,326.13,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.89,213a12.36,12.36,0,0,1,11.17-1.5,39.1,39.1,0,0,1,11.83-13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.53,209.94s19.6,13.94,31.47,10.49,8.55-13.66,8.55-13.66",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px",
      opacity: 0.47000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.42,207.6s24.61,11.31,28.75-4.7",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px",
      opacity: 0.47000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.39,270.21s4.68,9.09,8.35,8.94,10.4-9.93,10.4-9.93-3.63,4.68-9.14,5.16C305.37,274.7,299.39,270.21,299.39,270.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.71,336.58l.76-.35a2.06,2.06,0,0,0,1.19-2.27l-.15-.92a2.05,2.05,0,0,0-1.89-1.72l-.92-.08a2.05,2.05,0,0,1-1.71-1.17c-.25-.52-.51-1-.8-1.52a2.05,2.05,0,0,1,0-2.06l.47-.8a2.13,2.13,0,0,0-.33-2.55l-.66-.65a2,2,0,0,0-2.55-.31l-.81.48a2.05,2.05,0,0,1-2.06,0,16.64,16.64,0,0,0-4.19-1.71,2.06,2.06,0,0,1-1.48-1.5l-.24-1a2,2,0,0,0-2.06-1.58h-.92a2,2,0,0,0-2.06,1.57l-.26,1a2,2,0,0,1-1.45,1.48c-.52.15-1,.3-1.52.49a2.07,2.07,0,0,1-2.05-.38l-.83-.71a2,2,0,0,0-2.53-.15l-.73.5a2,2,0,0,0-.77,2.48l.37,1a2.07,2.07,0,0,1-.32,2.06,14.16,14.16,0,0,0-.93,1.23,2.05,2.05,0,0,1-1.91.88l-1-.09a2,2,0,0,0-2.17,1.37l-.33.9a2.06,2.06,0,0,0,.75,2.41l1,.67a2.09,2.09,0,0,1,.86,1.89,12.31,12.31,0,0,0-.08,1.61h0a2.13,2.13,0,0,1-1,1.75l-1,.54a2.06,2.06,0,0,0-1,2.37l.24.9a2.05,2.05,0,0,0,2.06,1.54h1a2.08,2.08,0,0,1,1.8,1c.28.5.57,1,.89,1.43a2.06,2.06,0,0,1,.16,2.06l-.42.88a2.06,2.06,0,0,0,.54,2.51l.71.6a2.06,2.06,0,0,0,2.56.09l.74-.52a2,2,0,0,1,2-.19c.53.25,1.06.47,1.61.68a2.05,2.05,0,0,1,1.31,1.58l.15.9a2.07,2.07,0,0,0,1.9,1.72l.94.08a2.05,2.05,0,0,0,2.14-1.39l.29-.8a2.07,2.07,0,0,1,1.6-1.35,17.18,17.18,0,0,0,1.73-.37,2.07,2.07,0,0,1,2,.54l.61.62a2.06,2.06,0,0,0,2.52.34l.82-.46a2.06,2.06,0,0,0,1-2.38l-.23-.8a2.07,2.07,0,0,1,.52-2.06,17,17,0,0,0,1.22-1.33,2.06,2.06,0,0,1,2-.7l.83.16a2.06,2.06,0,0,0,2.27-1.18l.39-.84a2.05,2.05,0,0,0-.58-2.51l-.62-.51a2,2,0,0,1-.76-1.91,16.57,16.57,0,0,0,.19-1.85A2.06,2.06,0,0,1,327.71,336.58Zm-12.39.53a5.44,5.44,0,1,1-5.44-5.43h0a5.42,5.42,0,0,1,5.43,5.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.33,370.28a20.84,20.84,0,0,1-2.67,2.47,22.4,22.4,0,0,0-5.69,9.08,7.41,7.41,0,0,0,0,4.92c1.21,3,5.05,6,8.12,4.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.09,365c-2.93-.46-5.81,1.24-7.81,3.41s-3.39,4.85-5.21,7.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.86,395.07a19.81,19.81,0,0,1-11.59-1.24,32.78,32.78,0,0,1-6.42-4.52l-7.6-6.28c-1.22-1-2.57-2.45-2.07-3.95,0,0,12.7-66.93,14.69-74.17,2.31-8.35,11.61-14,11.61-14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.15,371a21.51,21.51,0,0,1,7.21,9.63,53.21,53.21,0,0,1,2.27,10.93c-2,1.1-6,4-9.48,4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.58,365.43c3.08-.82,6.13,1.28,8.46,3.46s4.72,4.71,7.89,5.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.17,400.21c6-.63,11.4-3.9,15.72-8.07s7.64-9.23,10.93-14.24c2.67-4.06,5.38-8.23,6.55-12.94,0,0-10.53-34.81-16.38-51-6.1-16.83-12.68-21.13-12.68-21.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.58,365.43c5.43-4.56,13.76-.87,19.6,2.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.33,
    y: 346.8,
    width: 94.81,
    height: 54.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.86,
    y: 401.29,
    width: 95.72,
    height: 2.85,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.86 401.29 355.15 346.8 355.58 401.29 259.86 401.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.86 401.29 355.15 346.8 355.58 401.29 259.86 401.29",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.02,
    cy: 373.16,
    r: 8.08,
    transform: "translate(-173.36 327.8) rotate(-45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.33,
    y: 346.8,
    width: 94.81,
    height: 54.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.06,236.06s2.08,19,4.72,22.43,11.12,15.84,20.36,15.65,15.27-12.07,16.78-17.16a88.22,88.22,0,0,0,3.39-19.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.88,255s6.85-3.54,2.43-12.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0293396711349487px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsBro);
export default __webpack_public_path__ + "static/media/cs-bro.494869e8d6d90c364a7cc6bfac353247.svg";
export { ForwardRef as ReactComponent };